__turbopack_context__.v({
  "active": "imageGallery-module-scss-module__Lm289W__active",
  "buttonNext": "imageGallery-module-scss-module__Lm289W__buttonNext",
  "buttonPrevious": "imageGallery-module-scss-module__Lm289W__buttonPrevious",
  "carousel": "imageGallery-module-scss-module__Lm289W__carousel",
  "carouselImage": "imageGallery-module-scss-module__Lm289W__carouselImage",
  "container": "imageGallery-module-scss-module__Lm289W__container",
  "controls": "imageGallery-module-scss-module__Lm289W__controls",
  "gallery": "imageGallery-module-scss-module__Lm289W__gallery",
  "galleryImage": "imageGallery-module-scss-module__Lm289W__galleryImage",
  "navIcon": "imageGallery-module-scss-module__Lm289W__navIcon",
  "relativeWrapper": "imageGallery-module-scss-module__Lm289W__relativeWrapper",
});
